import { Status as APIStatus } from '~api/som_search';

import { Card, DotBadge } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { getStatusColor, getStatusLabel } from '~src/utils/status-helpers';

export interface StatusProps {
  status: APIStatus;
}

export function Status({ status }: StatusProps) {
  const { t } = useTranslation();
  return (
    <Card.Wrapper>
      <Card.Header>{t('common.status')}</Card.Header>
      <Card.Content>
        <DotBadge variant={getStatusColor(status)}>{t(getStatusLabel(status))}</DotBadge>
      </Card.Content>
    </Card.Wrapper>
  );
}
